import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Mainheader slot", -1)
const _hoisted_2 = { class: "page-items__controls" }
const _hoisted_3 = { class: "page-items__summary" }
const _hoisted_4 = {
  key: 0,
  class: "page__loading-item"
}
const _hoisted_5 = {
  key: 1,
  class: "page__appending-item"
}
const _hoisted_6 = {
  key: 0,
  class: "page__no-data-item label-m"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Left bar slot", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Sidebar slot", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "Multitool slot", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NLoadingCircle = _resolveComponent("NLoadingCircle")!
  const _component_PageContentLayout = _resolveComponent("PageContentLayout")!

  return (_openBlock(), _createBlock(_component_PageContentLayout, {
    ref: "pageContent",
    "onUpdate:scrollBottom": _cache[0] || (_cache[0] = (v) => _ctx.$emit('update:scrollBottom', v)),
    "has-sidebar": _ctx.state.showSidebar,
    "has-viewer": _ctx.state.showViewer,
    "has-player": _ctx.state.showPlayer,
    "has-overlay": _ctx.state.showOverlay,
    "has-multitool": _ctx.state?.showMultitool,
    "has-left-bar": _ctx.state?.showLeftBar,
    "has-main-header": _ctx.state?.showMainHeader
  }, {
    mainheader: _withCtx(() => [
      _renderSlot(_ctx.$slots, "mainheader", {}, () => [
        _hoisted_1
      ])
    ]),
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "filters")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "summary", {}, () => [
          _renderSlot(_ctx.$slots, "statistic")
        ])
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "items2"),
      _createElementVNode("div", {
        class: _normalizeClass(["page-items__container", _ctx.classes])
      }, [
        _renderSlot(_ctx.$slots, "items"),
        (_ctx.module.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_NLoadingCircle)
            ]))
          : _createCommentVNode("", true),
        (_ctx.module.appending)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_NLoadingCircle)
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "items-empty", {}, () => [
          (_ctx.module.loaded && !_ctx.module.items.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('common.no_data', 'f')), 1))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    "left-bar": _withCtx(() => [
      _renderSlot(_ctx.$slots, "left-bar", {}, () => [
        _hoisted_7
      ])
    ]),
    sidebar: _withCtx(() => [
      _renderSlot(_ctx.$slots, "sidebar", {}, () => [
        _hoisted_8
      ])
    ]),
    "image-viewer": _withCtx(() => [
      _renderSlot(_ctx.$slots, "image-viewer")
    ]),
    multitool: _withCtx(() => [
      _renderSlot(_ctx.$slots, "multitool", {}, () => [
        _hoisted_9
      ])
    ]),
    player: _withCtx(() => [
      _renderSlot(_ctx.$slots, "player")
    ]),
    overlay: _withCtx(() => [
      _renderSlot(_ctx.$slots, "overlay")
    ]),
    _: 3
  }, 8, ["has-sidebar", "has-viewer", "has-player", "has-overlay", "has-multitool", "has-left-bar", "has-main-header"]))
}